"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAmountSchema = exports.CurrencyAmountSchema = void 0;
const zod_1 = require("zod");
exports.CurrencyAmountSchema = zod_1.z.object({
    number: zod_1.z.number({ required_error: 'value number is required' }),
    currencyID: zod_1.z.string({ required_error: 'value currencyID is required' }),
});
exports.TokenAmountSchema = zod_1.z
    .object({
    number: zod_1.z.number({ required_error: 'amount number is required' }),
    bigint: zod_1.z.string().optional().nullable(),
    tokenID: zod_1.z.string({ required_error: 'amount tokenID is required' }),
    currencyAmounts: zod_1.z
        .array(exports.CurrencyAmountSchema)
        .optional()
        .nullable()
        .refine((val) => val === null || val === undefined || val.length > 0, { message: 'currencyAmounts must have at least one item if provided' }),
})
    .refine((data) => {
    if (!data.bigint)
        return true;
    try {
        BigInt(data.bigint);
        return true;
    }
    catch {
        return false;
    }
}, { message: 'bigint must match the number representation if provided', path: ['bigint'] });
